import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@optic-delight/icons';

/**
 * Used in conjunction with `NavProgress`
 */
const NavProgressItem = ({ eventKey, children, href, complete, active, ...props }) => {
	return (
		<a key={eventKey} {...props} href={href} className={`progress-dot-step ${active ? 'current' : complete ? 'complete' : ''}`}>
			<div className="progress-dot-label">{children}</div>
			<div className="progress-dot-icon">{complete && <Icon size="sm" icon="check" />}</div>
		</a>
	);
};
NavProgressItem.displayName = 'NavProgressItem';

NavProgressItem.defaultProps = {
	href: '#',
	complete: false,
	active: false
};

NavProgressItem.propTypes = {
	children: PropTypes.string.isRequired,
	eventKey: PropTypes.string,

	/**
	 * the HTML href attribute for the NavProgress Item
	 */
	href: PropTypes.string.isRequired,

	/**
	 * the completed state of the NavProgress Item. Set from `NavProgress`
	 */
	complete: PropTypes.bool,

	/**
	 * the active state of the NavProgress Item. Set from `NavProgress` defaultActiveKey
	 */
	active: PropTypes.bool
};

export default NavProgressItem;
